var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGooglesheets = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23A566",
    fillRule: "evenodd",
    d: "M31 33.708a1.78 1.78 0 0 1-1.77 1.792H10.77A1.78 1.78 0 0 1 9 33.708V6.3c0-.99.792-1.792 1.77-1.792h11.87l8.36 8.67v20.531Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C8F5A",
    fillRule: "evenodd",
    d: "M23.56 12.957 31 20.154l-.022-6.987h-6.584c-.3 0-.581-.075-.829-.208h-.004Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ED1B1",
    d: "M22.625 11.375c0 .987.79 1.789 1.765 1.791H31L22.625 4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.721 29.767H14.28V19.735h11.44v10.032Zm-6.429-6.807h-3.598v-1.792h3.598zm0 2.747h-3.598v-1.672h3.598zm0 2.627h-3.598v-1.552h3.598zm5.014 0h-3.598v-1.552h3.598zm0-2.627h-3.598v-1.672h3.598zm0-2.747h-3.598v-1.792h3.598z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglesheets);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/googlesheets.168e8254.svg";